module.exports = __webpack_public_path__ + "img/dice-icon-outline.d33345f4.svg";